export type LojaAgregador = {
    id: number
    name: string
    description: string
    information: string
    order: number
    classificationId: string
    pluginspaceId: number
    image: string
    config: Config
    corporatename: string
    corporateName: string
    cnpj: string
    link: string
    type: string
    instagram: string
    phoneWhatsapp: string
    active: boolean
    zipCode: string
    exclusive: boolean
}
export type RedeSocial = {
    status: boolean
    link: string
    type: string
}

export type Config = {
    address: Address,
    images: Image[]
    product: Product[]
    redesSociais: RedeSocial[]
    storeConfig: StoreConfig
}

export enum typeStore {
    TURISM = "turismo", // Listagem das Lojas Cadastradas na categoria
    RESTAURANT = "restaurante", // Pagina do conteudo que vincula uma unica loja e demais informaçoes adicionais
    STORE = "loja",
    CULTURE = 'cultura',
    LAZER = 'lazer',
    HOSPITALITY = "hospitality",
}

export type StoreConfig = {
    isStore: boolean,
    isExclusive: boolean
    link: string
    isFree: boolean
    enterFee: number
    type: typeStore
    capacity: number
    time: string
}

export type Address = {
    city: string
    country: string
    district: string
    number: string
    state: string
    street: string
    extra: string
}

export type Image = {
    image: string | File
}

export type Product = {
    description: string
    image: string | File
    value: number
    urlExternal?: string
}

export type ImageLoadingState = {
    principal: boolean
    card1: boolean
    card2: boolean
    card3: boolean
    card4: boolean
    card5: boolean
    product0: boolean
    product1: boolean
    product2: boolean
    product3: boolean
    product4: boolean
}


export type CreateLojaAgregadorDTO = {
    name: string
    description: string
    information: string
    order: number
    classificationId: string
    pluginspaceId: number
    image: string | File
    config: Config
    corporatename: string
    corporateName: string
    cnpj: string
    link: string
    type: string
    instagram: string
    phoneWhatsapp: string
    active: boolean
    zipCode: string
    exclusive: boolean
}

export type UpdateLojaAgregadorDTO = CreateLojaAgregadorDTO


export const defaultStore: CreateLojaAgregadorDTO = {
    name: '',
    description: '',
    information: '',
    order: 0,
    classificationId: '',
    pluginspaceId: 0,
    image: '',
    config: {
        address: {
            city: '',
            country: '',
            district: '',
            number: '',
            state: '',
            street: '',
            extra: '',
        },
        images: [],
        product: [],
        redesSociais: [],
        storeConfig: {
            isStore: false,
            isExclusive: false,
            link: '',
            isFree: false,
            enterFee: 0,
            type: typeStore.TURISM,
            capacity: 0,
            time: ''
        }
    },
    corporatename: '',
    corporateName: '',
    cnpj: '',
    link: '',
    type: 'food',
    instagram: '',
    phoneWhatsapp: '',
    active: true,
    zipCode: '',
    exclusive: false,
}

export type CardProduct = {
    image?: File | null | string | undefined
    value?: string
    description?: string
    urlExternal?: string
}

export type SelectOptions = {
    value: number,
    select: string
    label: string
}